import { useContext, useState } from "react";
import cn from "classnames";
import { Icon, Button } from "capitalrx-components-2.0";
import RequestModal from "@/components/GetCardModals/RequestModal";
import { RequestTypes } from "@/types/AdvantageCardRequest";

import styles from "./ButtonComponent.module.scss";
import { ThemeSelectorContext } from "@/context/index";

interface Props {
  buttonText: string;
  requestType?: RequestTypes;
  iconName: string;
  color: "black" | "white" | "darkblue" | "turquoise" | "lightgrey" | "red" | "green" | "orange";
  className: string;
  testId?: string;
}

const ButtonComponent: React.FC<Props> = (props: Props) => {
  const { buttonText, requestType, iconName, color, className, testId } = props;
  const [showModalState, setShowModalState] = useState(false);
  const [modalType, setModalType] = useState<RequestTypes>(RequestTypes.null);
  const { client } = useContext(ThemeSelectorContext);

  const buttonClass = cn(styles.CardButton, { [styles.WhitelabelButton]: !!client });

  const showModal = (type: RequestTypes): void => {
    setModalType(type);
    setShowModalState(true);
  };

  const closeModal = (): void => {
    setShowModalState(false);
  };

  const buttonComponent = (
    <Button
      testId={testId}
      className={buttonClass}
      onClick={() => showModal(requestType)}
      iconLocation="left"
      color="darkblue"
      size="small"
    >
      <Icon name={iconName} size="small" color={color} className={className} />
      {buttonText}
    </Button>
  );

  return (
    <>
      <div className={styles.ButtonAlignment}>{buttonComponent}</div>
      <RequestModal type={modalType} visible={showModalState} onClose={closeModal} />
    </>
  );
};

export default ButtonComponent;
